import { useState } from 'react';

const DEEPLINKS = [
    { pattern: 'https://...', example: 'https://izenu.ao/premium', desc: 'Qualquer URL externa (abre em webview)' },
    { pattern: 'app://Artist?id=<user_id>', example: 'app://Artist?id=42', desc: 'Abre a página do artista' },
    { pattern: 'app://play?music_id=<id>', example: 'app://play?music_id=101', desc: 'Toca a música (e adiciona à queue)' },
    { pattern: 'app://PlayMusic?id=<id>', example: 'app://PlayMusic?id=101', desc: 'Mesmo que app://play' },
    { pattern: 'app://song?id=<id>', example: 'app://song?id=101', desc: 'Abre ecrã de detalhe da música' },
    { pattern: 'app://DeepLinkingMusic?id=<id>', example: 'app://DeepLinkingMusic?id=101', desc: 'Mesmo que app://song' },
    { pattern: 'app://PlaylistMusics?id=<playlist_id>', example: 'app://PlaylistMusics?id=15', desc: 'Abre a playlist' },
    { pattern: 'app://SinglePost?post_id=<id>', example: 'app://SinglePost?post_id=77', desc: 'Abre um post específico' },
    { pattern: 'app://RadioShows', example: 'app://RadioShows', desc: 'Abre lista de shows de rádio' },
    { pattern: 'app://SeeMorePodcasts', example: 'app://SeeMorePodcasts', desc: 'Abre lista de podcasts' },
    { pattern: 'app://Eventos', example: 'app://Eventos', desc: 'Abre lista de eventos' },
    { pattern: 'app://Premium', example: 'app://Premium', desc: 'Abre a página de subscrição Premium (nativa)' },
];

export default function DeepLinksHelp() {
    const [open, setOpen] = useState(false);

    const copy = (text) => {
        try {
            navigator.clipboard.writeText(text);
        } catch (e) {
            // noop
        }
    };

    return (
        <div style={{ marginBottom: 16, border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden', background: '#f9fafb' }}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                style={{
                    width: '100%',
                    padding: '10px 14px',
                    background: 'transparent',
                    border: 'none',
                    color: '#111827',
                    fontSize: 13,
                    fontWeight: 600,
                    textAlign: 'left',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <span>Links aceites ({DEEPLINKS.length}) — URL externa ou deeplink interno</span>
                <span style={{ fontSize: 12, color: '#6b7280' }}>{open ? '▲' : '▼'}</span>
            </button>
            {open && (
                <div style={{ borderTop: '1px solid #e5e7eb', maxHeight: 320, overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                        <thead>
                            <tr style={{ background: '#f3f4f6', color: '#4b5563', textTransform: 'uppercase', fontSize: 10 }}>
                                <th style={{ padding: 8, textAlign: 'left' }}>Padrão</th>
                                <th style={{ padding: 8, textAlign: 'left' }}>Exemplo</th>
                                <th style={{ padding: 8, textAlign: 'left' }}>Descrição</th>
                            </tr>
                        </thead>
                        <tbody>
                            {DEEPLINKS.map((dl, i) => (
                                <tr key={i} style={{ borderTop: '1px solid #e5e7eb', color: '#1f2937' }}>
                                    <td style={{ padding: 8, fontFamily: 'monospace', color: '#4b5563' }}>{dl.pattern}</td>
                                    <td style={{ padding: 8 }}>
                                        <button
                                            type="button"
                                            onClick={() => copy(dl.example)}
                                            title="Copiar"
                                            style={{
                                                background: '#e5e7eb',
                                                border: 'none',
                                                padding: '3px 8px',
                                                borderRadius: 4,
                                                fontFamily: 'monospace',
                                                fontSize: 11,
                                                color: '#111827',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {dl.example}
                                        </button>
                                    </td>
                                    <td style={{ padding: 8, color: '#6b7280' }}>{dl.desc}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{ padding: '8px 12px', color: '#6b7280', fontSize: 11, borderTop: '1px solid #e5e7eb' }}>
                        Deixa em branco se não quiseres que a capa seja clicável.
                    </div>
                </div>
            )}
        </div>
    );
}
